import HeroBanner from "../components/hero/hero";
import Headline from "../components/headline/headline";
import TrainingPreviewModule from "../components/training-preview-module/training-preview-module";
import ClientsBanner from "../components/clients-banner/clients-banner";
import TestimonialModule from "../components/testimonial-module/testimonial-module";
import FullWidthCta from "../components/full-width-cta/full-width-cta";

export default function Home() {
  const urlPrefix: string = "/training#";
  return (
    <>
      <HeroBanner/>
      <Headline />
      <TrainingPreviewModule fromPage={false} urlPrefix={urlPrefix} />
      <TestimonialModule />
      <ClientsBanner />
      <FullWidthCta 
        ctaText = "We look forward hearing from you. Get in touch and let's get the ball rolling."
        buttonText = "Get in touch"
        buttonLink = "/get-in-touch" 
        theme= "light-theme"
      />
    </>
  );
}
